import { Loadstone, type LoadstoneProps } from './loadstone'
import { contextBusyConfig, contextReadyConfig } from './loadstone-presets'

export function ContextBusyLoadstone(props: Omit<LoadstoneProps, 'config'>): JSX.Element {
  return <Loadstone config={contextBusyConfig} {...props} />
}

export function ContextReadyLoadstone(props: Omit<LoadstoneProps, 'config'>): JSX.Element {
  return <Loadstone config={contextReadyConfig} {...props} />
}
